import { Col, Row } from 'react-bootstrap';
import { WaitListInput } from 'components/WaitListInput';

export const JoinWaitlist = ({ type }) => (
  <Row className="join-club">
    <Col className="text-center">
      <p className="join-club__title text-center">Join our waitlist for early access!</p>
      <Row className="justify-content-center">
        <WaitListInput type={type} />
      </Row>
    </Col>
  </Row>
);
